import { initEnv, inBiliApp, biliBridge } from '@bilibili/js-bridge'
initEnv()

export function goToLogin() {
  return new Promise(resolve => {
    if (inBiliApp) {
      biliBridge.callNative({
        method: 'auth.login',
        data: {
          type: 'default',
        },
        onLogin(data: any) {
          if (data && Number(data.state)) resolve(true)
        },
      })
    } else {
      location.href = 'https://passport.bilibili.com/login?gourl=' + encodeURIComponent(location.href)
    }
  })
}
export default function login() {
  goToLogin().then(() => location.reload())
}
